
let language = {
    FILE_LIBRARY_BAR_SEARCH_BTN: "search",
    FILE_LIBRARY_BAR_RESET_BTN: "reset",
    FILE_LIBRARY_BAR_UPLOAD_BTN: "upload files",
    FILE_LIBRARY_BAR_SEARCH_TYPE_PLACEHOLDER: "Search file library",
    FILE_LIBRARY_BAR_SEARCH_ALL_PLACEHOLDER: "All",
    
    // 
    "fileLibrary:Sort:Created:Newest": "Created: newest first",
    "fileLibrary:Sort:Created:Oldest": "Created: oldest first",
    "fileLibrary:Sort:Name:Asc": "Name: A to Z",
    "fileLibrary:Sort:Name:Desc": "Name: Z to A",
    
    "fileLibrary:Filter:AllType": "All type",
    "fileLibrary:Filter:Catalog": "Folder",
    "fileLibrary:Filter:FileObject": "File"
};

export { language }